<template>
  <div class="combobox-transaction-or-transaction-item-display">
    <ComboboxPurchaseItemDisplay
      v-if="transactionOrTransactionItem instanceof PurchaseItem"
      :item="transactionOrTransactionItem"
    />
    <ComboboxSaleItemDisplay
      v-else-if="transactionOrTransactionItem instanceof SaleItem"
      :item="transactionOrTransactionItem"
    />
    <ComboboxPurchaseDisplay
      v-else-if="transactionOrTransactionItem instanceof Purchase"
      :item="transactionOrTransactionItem"
      :error="Array.isArray(error) ? error[0] : error"
    />
    <ComboboxSaleDisplay v-else :item="transactionOrTransactionItem" />
  </div>
</template>

<script setup lang="ts">
import { PurchaseItem } from "@/models/purchase-item.model"
import { SaleItem } from "@/models/sale-item.model"
import { Purchase } from "@/models/purchase.model"
import { Sale } from "@/models/sale.model"
import { computed } from "vue"
import ComboboxPurchaseDisplay from "@/components/administration/combobox-display-templates/ComboboxPurchaseDisplay.vue"
import ComboboxPurchaseItemDisplay from "@/components/administration/combobox-display-templates/ComboboxPurchaseItemDisplay.vue"
import ComboboxSaleDisplay from "@/components/administration/combobox-display-templates/ComboboxSaleDisplay.vue"
import ComboboxSaleItemDisplay from "@/components/administration/combobox-display-templates/ComboboxSaleItemDisplay.vue"
import type { BaseException } from "@/exceptions/base-exception.exception.ts"

const props = defineProps<{
  item: PurchaseItem | SaleItem | Purchase | Sale | [Purchase] | [Sale]
  error?: BaseException | (BaseException | undefined)[] // Currently only supports purchase validation errors.
}>()

const transactionOrTransactionItem = computed(() => {
  if (
    props.item instanceof PurchaseItem ||
    props.item instanceof SaleItem ||
    props.item instanceof Purchase ||
    props.item instanceof Sale
  ) {
    return props.item
  }
  return props.item[0]
})
</script>

<style scoped></style>
